module.exports = __webpack_public_path__ + "img/56ne.9c0f2746.svg";